let en = {
  translations: {
    "To get started, edit <1>src/App.js</1> and save to reload.":
      "To get started, edit <1>src/App.js</1> and save to reload.",
    "Welcome to React": "Welcome to React and react-i18next",
  },
};

export default en;
